export enum ModuleTokens {
  Name = 'clientServicesBase'
}

export enum ClientServiceStatuses {
  active = 'ACTIVE',
  terminated = 'TERMINATED'
}
